module.exports = __webpack_public_path__ + "img/collection-engagementRingsSolitaire.78ffa27.jpg";